<!-- 特价申请数据操作 -->
<template>
    <div>
        <!--dataActionBox.boxTitle  -->
        <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form id="mainInfo" class="baseForm" size="mini" label-position="right"
                                        label-width="120px">
                                        <el-row>
                                            <el-form-item>
                                                <label slot="label" :style="$common.labelStyle('销往单位')"
                                                    v-html="'销往单位'"></label>
                                                    <el-tooltip  class="item" :disabled="sendDataInfo.cmName==null||sendDataInfo.cmName==''?true:false || sendDataInfo.cmName.length<=9" effect="dark"
        :content="sendDataInfo.cmName" placement="bottom-start">
                                                <el-input @keyup.enter.native="openSearch('3391151360249856', 'cmName')"
                                                    v-model="sendDataInfo.cmName" clearable>
                                                    <el-button @click="openSearch('3391151360249856', 'cmName')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="申请商品">
                                                <label slot="label" :style="$common.labelStyle('申请商品')"
                                                    v-html="'申请商品'"></label>
                                                    <el-tooltip  class="item" :disabled="sendDataInfo.bgmName==null||sendDataInfo.bgmName==''?true:false || sendDataInfo.bgmName.length<=9" effect="dark"
        :content="sendDataInfo.bgmName" placement="bottom-start">
                                                <el-input @keyup.enter.native="openSearch('7067112496762880', 'bgmName')"
                                                    v-model="sendDataInfo.bgmName" clearable>
                                                    <el-button @click="openSearch('7067112496762880', 'bgmName')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="申请售价">
                                                <label slot="label" :style="$common.labelStyle('申请售价')"
                                                    v-html="'申请售价'"></label>
                                                <el-input v-model="sendDataInfo.wosaAppprice" type="number" :min="0"
                                                    clearable></el-input>
                                            </el-form-item>
                                            <el-form-item label="申请截止日期">
                                                <label slot="label" :style="$common.labelStyle('申请截止日期')"
                                                    v-html="'申请截止日期'"></label>
                                                <el-date-picker v-model="sendDataInfo.wosaEnddate"
                                                    @change="changeTime(sendDataInfo.wosaEnddate)" type="date"
                                                    placeholder="有效期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp"></el-date-picker>
                                                <!-- <df-date  v-model="sendDataInfo.wosaEnddate"></df-date> -->
                                            </el-form-item>
                                            <el-form-item label="最低售价">
                                                <label slot="label" :style="$common.labelStyle('最低售价')"
                                                    v-html="'最低售价'"></label>
                                                <el-input v-model="sendDataInfo.lowestPrice" type="number" :min="0"
                                                    disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="生产日期">
                                                <label slot="label" :style="$common.labelStyle('生产日期')"
                                                    v-html="'生产日期'"></label>
                                                <el-date-picker v-model="sendDataInfo.prodate" disabled type="date"
                                                    placeholder="生产日期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp"></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="批号">
                                                <label slot="label" :style="$common.labelStyle('批号')"
                                                    v-html="'批号'"></label>
                                                <el-input v-model.trim="sendDataInfo.batchno" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="有效期">
                                                <label slot="label" :style="$common.labelStyle('有效期')"
                                                    v-html="'有效期'"></label>
                                                <el-date-picker v-model="sendDataInfo.expidate" disabled type="date"
                                                    placeholder="有效期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp"></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="货主">
                                                <label slot="label" :style="$common.labelStyle('货主')"
                                                    v-html="'货主'"></label>
                                                <el-input v-model.trim="sendDataInfo.coName" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="申请原因">
                                                <label slot="label" :style="$common.labelStyle('申请原因')"
                                                    v-html="'申请原因'"></label>
                                                <el-input v-model.trim="sendDataInfo.wosaAppreason" type="textarea"
                                                    maxlength="64" show-word-limit clearable></el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
                <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
                    :modal-append-to-body='true' :append-to-body="true">
                    <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
                        @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
                </el-dialog>
            </div>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue"
export default {
    name: 'priceApplicationAction',
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                bgmId: '',
                bgmName: '',
                cmId: '',//销往单位
                cmName: '',
                coId: "",	//货主
                coName: "",

                wosaAppprice: "",  // 申请售价
                wosaAppreason: '', // 申请原因
                batchno: '', // 批号
                expidate: '', // 	有效期
                wosaEnddate: new Date().getTime(), // 申请截止日期
                lowestPrice: '', // 最低售价
                prodate: '', // 	生产日期
                "wosaReserves1": "",
                "wosaReserves2": "",
                "wosaReserves3": "",
                "wosaReserves4": "",
                "wosaReserves5": "",
                "wosaReserves6": "",
                // acType:1, // 0自动提交，1手动提交
            },
            // selectDataTable:false,
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            cmId: 0,
            parentSearchData: {},
            tabForm: [
                {
                    jciName: ""
                }
            ]

        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.wosaAppprice'() {
            // var dataInfo = this.sendDataInfo.woApplyDetails[goodsIndex]
            // // if(!dataInfo.psprice){
            // // 	return false
            // // }

            // var sendData = {
            // 	"bgmId":dataInfo.bgmId,
            // 	"batchno": dataInfo.batchno,
            // 	"wosaAppprice": dataInfo.psprice,
            // 	"expidate": dataInfo.expidate,
            // 	"prodate": dataInfo.prodate,
            // 	"cmId":this.sendDataInfo.bgmId
            // }

            // let responseData =  await this.$http.getGoodsSockPrice(sendData)

            // let lowData = {
            // 	batchno: "",
            // bgmId: 0,
            // cmId: 0,
            // expidate: 0,
            // prodate: 0,
            // wosaAppprice: 0
            // }
            // getGoodsSockPrice
        }
    },
    //方法集合
    methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.sendDataInfo.wosaEnddate = time
                console.log(this.sendDataInfo.wosaEnddate)
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, field) {
            this.DialogVisible = true
            this.seId = sId
            this.parentSearchData[field] = this.sendDataInfo[field]
        },
        //检索带回数据
        changeInputModel(val) {
            console.log('search', val);
            if (!val || val == undefined) {
                return this.$message({
                    message: '未返回数据',
                    type: 'error'
                })
            }
            if (this.seId == '3391151360249856') {//销往单位返回
                this.cmId = val.cmId
                this.sendDataInfo.cmId = val.cmId
                this.sendDataInfo.cmName = val.cmName
            } else if (this.seId == '7067112496762880') {//商品返回
                this.sendDataInfo.bgmId = val.bgmId
                this.sendDataInfo.bgmName = val.bgmName
                this.sendDataInfo.coId = val.coId
                this.sendDataInfo.coName = val.coName

                this.sendDataInfo.batchno = val.batchno
                this.sendDataInfo.prodate = val.prodate
                this.sendDataInfo.expidate = val.expidate
                this.sendDataInfo.lowestPrice = val.lowestPrice
            }
            this.DialogVisible = false
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        //确认新增
        async sendDataAction() {
            console.log('this.sendDataInfo', this.sendDataInfo);
            if (this.sendDataInfo.bgmId == '') {
                this.$message({
                    message: '请选择商品',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.cmId == '') {
                this.$message({
                    message: '请选择销往单位',
                    type: 'error'
                });
                return false
            }
            //  || this.sendDataInfo.wosaAppprice<this.sendDataInfo.lowestPrice
            if (!this.sendDataInfo.wosaAppprice || this.sendDataInfo.wosaAppprice <= 0) {
                this.$message({
                    message: '请填写合理的申请价格',
                    type: 'error'
                });
                return false
            }

            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addSpecialPriceApply(this.sendDataInfo)
            } else {
                var responseData = await this.$http.setSpecialPriceApply(this.sendDataInfo)
            }

            if (responseData && responseData.status == 200) {
                this.initActionBox()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });

                this.$parent.getDataList()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            this.sendDataInfo.acType = 1
            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false
        },

        // selectDataAction(dataInfo){
        // 	this.sendDataInfo.bgmId = dataInfo.bgmId
        // 	this.sendDataInfo.bgmName = dataInfo.bgmName
        // 	this.sendDataInfo.batchno = dataInfo.batchno
        // 	this.sendDataInfo.prodate = dataInfo.prodate
        // 	this.sendDataInfo.expidate = dataInfo.expidate

        // 	this.selectDataTable = false
        // 	this.$message({
        // 		message: '添加成功',
        // 		type: 'success'
        // 	});

        // },
        async isShowData(name, value) {
            switch (name) {
                case 'bgmId':
                    var dataInfo = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.bgmId = dataInfo.bgmId
                        this.sendDataInfo.bgmName = dataInfo.bgmName
                    }
                    break;
                case 'cmId':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.cmId = dataInfo.cmId
                        this.sendDataInfo.cmName = dataInfo.cmName
                    }
                    break;


            }


        },

        openBox(cate, oldData = '') {
            this.initActionBox()

            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'ltr'
                for (const key in this.sendDataInfo) {
                    this.sendDataInfo[key] = oldData[key]
                }
                this.sendDataInfo.wosaId = oldData.wosaId

            }
            this.tabForm[0].jciName = this.dataActionBox.boxTitle
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true

        },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}
</style>